import { useEffect, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import useRoundGate from '../../hooks/useRoundGate';
import { clearGettime } from '../../utils/santaCookies';
import { extraMileHome } from '../../data/greenDiwali';
import { SANTA } from '../../data/santaStages';
import { isFromMobileAppClient } from '../../components/ExtraMileHeader/ExtraMileHeader';
import './WelcomePage.css';

function blockInspect() {
  const onContext = (event) => event.preventDefault();
  const onKey = (event) => {
    if (event.keyCode === 123) event.preventDefault();
    if (event.ctrlKey && event.shiftKey && (event.key === 'I' || event.key === 'J')) event.preventDefault();
    if (event.ctrlKey && event.key === 'u') event.preventDefault();
  };
  document.addEventListener('contextmenu', onContext);
  document.addEventListener('keydown', onKey);
  return () => {
    document.removeEventListener('contextmenu', onContext);
    document.removeEventListener('keydown', onKey);
  };
}

export default function WelcomePage() {
  const navigate = useNavigate();
  const { ready, status, error } = useRoundGate(0);
  const alreadyPlayedHandledRef = useRef(false);
  const finished = Boolean(status?.alreadyPlayed) || status?.nextStage === 'thank-you';

  useEffect(() => clearGettime(), []);
  useEffect(() => blockInspect(), []);

  useEffect(() => {
    if (!ready || !finished || alreadyPlayedHandledRef.current) return undefined;
    alreadyPlayedHandledRef.current = true;
    let left = false;
    Swal.fire({
      title: '',
      text: 'You have already played',
      icon: 'error',
      confirmButtonText: 'Close',
      allowOutsideClick: false,
      customClass: { confirmButton: 'hf-swal-close', popup: 'hf-swal-popup' },
      buttonsStyling: false,
    }).then(() => {
      if (left) return;
      if (isFromMobileAppClient() && typeof window.GameStatus?.postMessage === 'function') {
        window.GameStatus.postMessage('navigate_back');
        return;
      }
      window.location.href = extraMileHome();
    });
    return () => {
      left = true;
    };
  }, [ready, finished]);

  useEffect(() => {
    if (!ready || error || finished) return undefined;
    let justLoggedIn = false;
    try {
      justLoggedIn = sessionStorage.getItem('santaJustLoggedIn') === '1';
      sessionStorage.removeItem('santaJustLoggedIn');
    } catch {
      justLoggedIn = false;
    }
    if (!justLoggedIn) return undefined;
    const timer = setTimeout(() => navigate('/rounds/1'), 7000);
    return () => clearTimeout(timer);
  }, [ready, error, finished, navigate]);

  return (
    <div className="santa-intro">
      <div className="container-fluid">
        <div className="row">
          <div className="col-sm-8 col-md-7 col-lg-7 col-xs-10 auto santa-intro-frame">
            {error ? <p className="santa-intro-error">{error}</p> : null}
            <img src={`${SANTA}/Main_intro.gif`} className="desk2" alt="" />
            <img src={`${SANTA}/Mobile-Intro.gif`} className="img-fluid mob2" alt="" />
            <Link to="/rounds/1">
              <img src={`${SANTA}/PlayNow.png`} className="play-now" alt="Play now" />
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
